import { reactive } from 'sitekit-extensions'
import on from '../util/elements/on'
import destroys from '../util/elements/destroys'

export default function widgetContactForm (Site, $) {
  Site.widget('contact-form', {
    use: [ reactive() ],
    _create () {
      destroys(this)

      this.inputs = this.element.find('input, textarea').not('[type="submit"]')
      this.errorsEl = this.element.find('.error-container')
      this.elements = {}
      
      this.state = {
        form: this.serializeToObject()
      }

      this.hookEvents()
    },
    hookEvents () {
      const changedDisposer = on(
        this.inputs,
        'input',
        e => {
          $(e.currentTarget).addClass('dirty')
          this.setState(this.serializeToObject())
        }
      )
      
      const submitDisposer = on(
        this.element,
        'submit',
        e => {
          e.preventDefault()
          this.submit()
        }
      )

      this.destroys(
        changedDisposer,
        submitDisposer
      )
    },
    react () {
      const updateForm = () => this.controlledElements()

      // Render a single error to the error element
      const displaySingleError = err => {
        const singleErrorEl = $(`<div class="single-error">${err.error}</div>`)
        // On click focus the target input element 
        const clickDisposer = on(
          singleErrorEl,
          'click',
          e => {
            e.preventDefault()
            err.el.focus()
          }
        )

        // this.destroys handles clean up 
        this.destroys(clickDisposer)
        this.errorsEl.append(singleErrorEl)
      }

      const displayErrors = () => {
        /* 
          Reset error element
         */

        this.errorsEl.empty()

        // Dont render errors if they aren't any
        if (!this.state.errors.length) {
          this.errorsEl.addClass('hidden')
        } else {
          this.state.errors.forEach(displaySingleError)
          this.errorsEl.removeClass('hidden')
        }
      }

      // Listen to state changes
      this.changed('form', updateForm)
      this.changed('errors', displayErrors)
    },
    serializeToObject () {
      const inputs = this.inputs.toArray()
      const newFormObject = {}

      const singleInputToForm = input => {
        // Grab the input info
        const $el = $(input)
        const name = $el.attr('name')
        const value = $el.val()
        const dirty = $el.is('.dirty')

        // Create a standard form input object
        const inputObject = {
          name,
          el: $el,
          value,
          dirty
        }

        // Create errors from errorsFrom (using the form input object)
        inputObject.errors = dirty ? errorsFrom(inputObject) : false

        // Save input object to newFormObject
        newFormObject[name] = inputObject

        // Return currentInput object
        return inputObject
      }
      const inputObjects = inputs.map(singleInputToForm)

      // Reduce the errors of singleInputs into one array called allErrors
      const reduceErrors = (arr, item) => {
        if (!item.errors.length) return arr

        // If there are errors add them to the 
        return [
          ...arr,
          ...item.errors || []
        ]
      }
      const allErrors = inputObjects.reduce(reduceErrors, [])

      return {
        errors: allErrors,
        form: newFormObject
      }
    },
    getFormValue () {
      /*
      Return form state as an object with {inputName: inputValue}
      */
      const inputObjects = Object.entries(this.state.form)
      const inputObjectToKeyVal = (result, [name, entry]) => {
        result[name] = entry.value
        return result
      }

      return inputObjects.reduce(inputObjectToKeyVal, {})
    },
    controlledElements () {
      const formItems = Object.entries(this.state.form)

      const controlInput = ([name, entry]) => {
        // Cache the element by it's [name] field 
        if (!this.elements[name]) {
          this.elements[name] = this.element.find(`[name="${name}"]`)
        }

        const el = this.elements[name]

        el.val(entry.value)
        el.toggleClass('error', Boolean(entry.errors))
      }
      
      formItems.map(controlInput)
    },
    async submit () {
      this.inputs.addClass('dirty')
      
      this.setState(this.serializeToObject())

      if (this.state.errors.length) {
        console.log('had erriors', this.state)
      } else {
        const currentForm = this.getFormValue()
        const result = await new Promise(resolve => {
          Site.callAPI('submitContactForm', {
            sh_nonce: this.options.nonce.split('shde')[1],
            form: currentForm
          }, (error, resolved) => resolve(resolved))
        })
      }
    }
  })
}

function errorsFrom ({value, el}) {
  const formatters = {
    email: {
      test: str => /.+@.+\..*/.test(str) ? false : `Incorrect email format`
    }
  }
  const errors = []

  if (el.data('required')) {
    if (!value) {
      errors.push({
        el: el,
        error: `Missing required field ${el.data('label')}` 
      })
    }
  }

  const format = el.data('format')
  if (format) {
    const error = formatters[format].test(value)
    if (error) {
      errors.push({
        el: el,
        error
      })
    }
  }

  return errors.length ? errors : false
}
